import { render, staticRenderFns } from "./ClientHome.vue?vue&type=template&id=6a8e6a82&scoped=true&"
import script from "./ClientHome.vue?vue&type=script&lang=js&"
export * from "./ClientHome.vue?vue&type=script&lang=js&"
import style0 from "./ClientHome.vue?vue&type=style&index=0&id=6a8e6a82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8e6a82",
  null
  
)

export default component.exports